import { IDocGenStatusModel } from "../models/IDocGenStatusModel";
import { IPresignUrlModel } from "../models/IPresignUrlModel";
import ApiService from "./apiService";



class DocGenApiService {
    private apiService!: ApiService

    constructor() {
        this.apiService = ApiService.getInstance(process.env.REACT_APP_INTEGRATION_API ?? "");
    }

    public async getPresignResponse(transactionId: string, token: string, objectKeys: Array<string>) {
        const response = await this.apiService.get<IPresignUrlModel>(`/presign-url`, {
            headers: {
                "Authorization": `Bearer ${token}`
            },
            params: {
                RequestId: transactionId,
                ObjectKeysCsv: objectKeys.join(',')
            }
        });
        return response.data;
    }

    public async getDocGenStatus(transactionId: string, token: string) {
        try {
            const response = await this.apiService.get<IDocGenStatusModel>(`/docgen/${transactionId}`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error: any) {
            // Enhance error information for better debugging
            const enhancedError = {
                ...error,
                transactionId,
                endpoint: `/docgen/${transactionId}`,
                statusCode: error.response?.status,
                statusText: error.response?.statusText,
                responseData: error.response?.data
            };
            throw enhancedError;
        }
    }
}

export default DocGenApiService;